import React from 'react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Job } from '../../../lib/comeet';
import { JOB_DETAIL_DESCRIPTION_NAME } from '../../../consts/jobs';
import { RichText } from '../RichText';
import { useBI, useImpression, SECTION_NAMES } from '../../bi';

interface JobDescriptionSectionProps {
    job: Job;
}

export const JobDescriptionSection = ({ job }: JobDescriptionSectionProps) => {
    const details = (job.details ?? []).filter((detail) => detail.name !== JOB_DETAIL_DESCRIPTION_NAME);
    const bi = useBI();
    const impressionRef = useImpression<HTMLDivElement>(() =>
        bi.reportSectionImpression({ sectionName: SECTION_NAMES.jobDescription })
    );

    if (details.length === 0) {
        return null;
    }

    return (
        <Section fullWidth backgroundColor="white">
            <Stack
                ref={impressionRef}
                direction="column"
                alignItems="center"
                gap={{ default: '10', lg: '10' }}
                paddingX={{ default: '5', lg: '14' }}
                paddingY={{ default: '10', lg: '20' }}
            >
                {details.map((detail) => (
                    <Stack
                        key={`${detail.order}-${detail.name}`}
                        direction={{ default: 'column', lg: 'row' }}
                        gap={{ default: '4', lg: '20' }}
                        alignItems="flexStart"
                        width="100%"
                        maxWidth="920px"
                    >
                        <Typography
                            as="h2"
                            color="black"
                            fontWeight="semibold"
                            flexShrink={0}
                            width={{ default: '100%', lg: '30%' }}
                            size={{ default: 'h_md', lg: 'h_xxl' }}
                            letterSpacing="-2.4px"
                            style={{ lineHeight: 1.08 }}
                        >
                            {detail.name}
                        </Typography>
                        <Stack flexGrow={1}>
                            <RichText html={detail.value} />
                        </Stack>
                    </Stack>
                ))}
            </Stack>
        </Section>
    );
};
